module.exports = __webpack_public_path__ + "static/media/skeleton.fd7f5027.png";